'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/tooltip-template.html'));
var FlowMixChartController = function FlowMixChartController($scope, $filter, $timeout, constants, formatter, analysisMetricService, dataProviderService, visibilityManager, userPreferencesService, currentStateCriteriaService, representationService) {
  var defaultMetric = 'bookings';
  var rmNumberFormat = $filter('rmNumberFormat');
  var analysisMetric = analysisMetricService.getAnalysisMetric(constants.FLIGHT_SCREEN);
  $scope.metrics = analysisMetric.getMetricValues(constants.SERVICE_MODE, defaultMetric);
  $scope.metricLabels = analysisMetric.getAvailableLabels(constants.SERVICE_MODE);
  $scope.selectedMetric = _.find($scope.metricLabels, {
    id: userPreferencesService.getUserSettingComponent('topFlowMarketMetric') || defaultMetric
  }); //_.find($scope.metricLabels, {id: defaultMetric});

  function setMetrics(metric) {
    metric = metric || $scope.selectedMetric;
    $scope.selectedMetric = metric;
    $scope.metrics = analysisMetric.getMetricValues(constants.SERVICE_MODE, $scope.selectedMetric.id);
  }
  function reloadChart() {
    if (!visibilityManager.isFlowMixChartVisible()) {
      return;
    }
    var metric = $scope.selectedMetric.id;
    $scope.setLoadingMessage();
    return dataProviderService.getData(metric, $scope.screenState.dataRepresentation).then(function (chartData) {
      $scope.renderChart(chartData);
    }).then(function () {
      $scope.$emit('reload-carousel');
    }).then(function () {
      $scope.$broadcast('perfect-scrollbar:update');
    });
  }
  $scope.onBrushFilterApplied = function (event, brushFilter) {
    if (_.indexOf(['flightLevel'], brushFilter.filterType) > -1 && visibilityManager.isFlowMixChartVisible()) {
      // wait for chart became visible and then reload it
      $timeout(reloadChart, 0);
    }
  };
  $scope.changeMetricHandler = function (metric) {
    setMetrics(metric);
    reloadChart();
  };
  $scope.chartFormatters = {
    xAxisTickFormatter: formatter.identity,
    yAxisTickFormatter: function yAxisTickFormatter(d) {
      return rmNumberFormat(d, representationService.getYAxisFormat($scope.screenState.dataRepresentation));
    },
    tooltipFormatter: function tooltipFormatter(d) {
      var tooltipModel = representationService.prepareTooltipModel($scope.metrics, d, {
        representation: $scope.screenState.dataRepresentation,
        postDeparture: currentStateCriteriaService.isPostDeparture()
      }, $scope.screen);
      return tooltipTemplate(tooltipModel);
    }
  };
  $scope.onDataRepresentationChange = function () {
    if (visibilityManager.isFlowMixChartVisible()) {
      reloadChart();
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'flight-analysis-thematic-range-chart flow-mix-chart';
  $scope.reloadChart = reloadChart;
};
FlowMixChartController.$inject = ['$scope', '$filter', '$timeout', 'DataRetrieverConstantsService', 'FormatterService', 'AnalysisMetricService', 'FlowMixChartDataProviderService', 'FlightComponentVisibilityManagerService', 'UserPreferencesService', 'CurrentStateCriteriaService', 'DataRepresentationService'];
module.exports = FlowMixChartController;